import Request from '@/api/request';
const api = new Request('lk/');

export function getAddressStructure(keywords: string): Promise<any> {
    return api.post('dadata/suggest/address', {'query': keywords}).then((res: any) => res);
}

export function findByIdAddressStructure(id: string): Promise<any> {
    return api.post('dadata/findById/suggest/address', {'query': id}).then((res: any) => res);
}